import { staticColors } from '../../../const/colors/staticColors';
import { getDynamicPinningTableBackground } from './getDynamicPinningTableBackground';
export const getDynamicPinningTableCellBackgroundColor = ({ isPinningEnabled, isPinned, isRowHovered, }) => {
    if (!isPinningEnabled)
        return undefined;
    if (isRowHovered)
        return staticColors.dynamicTableRowHover;
    return getDynamicPinningTableBackground({ isPinned: isPinned ?? false });
};
